var map = {
	"./game1/bubble.png": "c159",
	"./game1/level1/bg.png": "4ee0",
	"./game1/level1/no1.png": "ca57",
	"./game1/level1/no2.png": "144a",
	"./game1/level1/yes1.png": "63f0",
	"./game1/level1/yes2.png": "e418",
	"./game1/level2/bg.png": "f59f",
	"./game1/level2/no1.png": "7efc",
	"./game1/level2/no2.png": "1b34",
	"./game1/level2/yes1.png": "114e",
	"./game1/level2/yes2.png": "be6a",
	"./game1/level3/bg.png": "3e83",
	"./game1/level3/no1.png": "87a9",
	"./game1/level3/no2.png": "c350",
	"./game1/level3/yes1.png": "4587",
	"./game1/level3/yes2.png": "8393",
	"./game1/no.png": "ea4e",
	"./game1/test.png": "af88",
	"./game1/yes.png": "4e79",
	"./game2/level1/bg.png": "85f3",
	"./game2/level1/no1.png": "febc",
	"./game2/level1/no2.png": "b0d8",
	"./game2/level1/yes1.png": "3ecc",
	"./game2/level1/yes2.png": "2ebf",
	"./game2/level2/bg.png": "cdb7",
	"./game2/level2/no1.png": "4b4d",
	"./game2/level2/no2.png": "4982",
	"./game2/level2/yes1.png": "3c51",
	"./game2/level2/yes2.png": "b3e5",
	"./game2/level3/bg.png": "8579",
	"./game2/level3/no1.png": "0c80",
	"./game2/level3/no2.png": "c89d",
	"./game2/level3/yes1.png": "f2e2",
	"./game2/level3/yes2.png": "8dda"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "f5ef";